import React, { useState } from 'react';
import { Input, InputGroup, Flex, Modal, ModalBody, ModalHeader, ModalFooter, Button, Alert, } from '@spothero/ui';
import { useSelector, useDispatch } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import { updateVehicle } from 'store/parking-pass/parking-pass-actions';
import trackReservationUpdated, { LOCATIONS, UPDATED_FIELDS, } from 'segment/events/reservation-updated';
import trackReservationVehicleUpdated from 'segment/events/reservation-vehicle-updated';
import trackReservationVehicleUpdateFailed from 'segment/events/reservation-vehicle-update-failed';
export const LICENSE_PLATE_FIELD = 'license_plate';
export const LICENSE_PLATE_FORM_ID = 'LICENSE_PLATE_FORM_ID';
const AddLicensePlateModal = ({ reservation, onClose, isOpen, activeStatus, onTrackedClick, }) => {
    const { control, handleSubmit, reset, formState: { isSubmitting }, } = useForm();
    const defaultValue = reservation.vehicle?.licensePlateValue || '';
    const [error, setError] = useState(null);
    const dispatch = useDispatch();
    const { accessKey } = useSelector((store) => store.parkingPass);
    const user = useSelector((state) => state.user.data);
    const resetModalState = () => {
        reset({
            [LICENSE_PLATE_FIELD]: defaultValue,
        });
    };
    const handleSuccess = () => {
        trackReservationUpdated({
            reservation,
            updatedProperties: [UPDATED_FIELDS.VEHICLE],
            location: LOCATIONS.PARKING_PASS,
            reservationPriceChanged: 0,
            activeStatus,
            user,
        });
        onClose();
    };
    const onSubmit = async ({ license_plate: licensePlateValue }) => {
        try {
            const response = await dispatch(updateVehicle({
                reservationId: reservation.rentalId,
                price: reservation.priceBreakdown.totalPrice,
                accessKey,
                guestVehicle: {
                    licensePlateValue,
                },
            }));
            // @ts-ignore
            if (response?.success) {
                trackReservationVehicleUpdated({
                    reservation,
                    user,
                    priceDifference: null,
                    newLicensePlate: licensePlateValue,
                    newVehicle: null,
                    view: 'add-license-plate',
                });
                handleSuccess();
            }
            else {
                trackReservationVehicleUpdateFailed({
                    reservation,
                    user,
                    priceDifference: null,
                    newLicensePlate: licensePlateValue,
                    newVehicle: null,
                    view: 'add-license-plate',
                    errors: [
                        {
                            message: 'Oops, we hit a snag saving your license plate. Please try again.',
                        },
                    ],
                });
                setError('Oops, we hit a snag saving your license plate. Please try again.');
            }
        }
        catch {
            setError('Oops, we hit a snag saving your license plate. Please try again.');
            return;
        }
    };
    const handleChangeVehicleSubmit = () => {
        onTrackedClick({
            clickTarget: 'Change Vehicle Modal Submit',
            isReservationChange: true,
        });
    };
    // Transform incoming user input before passing to hook-form change handler
    const handleChange = (onChangeHandler) => (e) => {
        setError(null);
        if (typeof e.target.value === 'string') {
            const newValue = e.target.value
                .replace(/[^a-z0-9]/gi, '')
                .toUpperCase();
            onChangeHandler({
                ...e,
                target: {
                    ...e.target,
                    value: newValue,
                },
            });
        }
        else {
            onChangeHandler(e);
        }
    };
    return (<Modal data-testid="AddLicensePlate" hasHeader hasFooter size="sm" isOpen={isOpen} hideCloseButton={isSubmitting} closeOnOverlayClick={false} onClose={onClose} onCloseComplete={resetModalState}>
            <ModalHeader>
                {defaultValue.length > 0 ? 'Change' : 'Add'} License Plate
            </ModalHeader>
            <ModalBody>
                <Flex as="form" onSubmit={handleSubmit(onSubmit)} id={LICENSE_PLATE_FORM_ID} width="100%" flexDirection="column">
                    <Controller name={LICENSE_PLATE_FIELD} shouldUnregister defaultValue={defaultValue} rules={{
            required: {
                value: true,
                message: 'Please enter your license plate',
            },
            maxLength: 10,
            minLength: 1,
            pattern: {
                value: /^[a-zA-Z0-9]+$/,
                message: 'Please enter a valid license plate',
            },
        }} control={control} render={({ field, fieldState }) => {
            return (<InputGroup width="100%" display="block" marginY={3}>
                                    <Input {...field} onChange={handleChange(field.onChange)} maxLength={10} isInvalid={fieldState.error} errorMessage={fieldState.error?.message} id={LICENSE_PLATE_FIELD} label="License Plate" width="100%"/>
                                </InputGroup>);
        }}/>
                    {error ? (<Alert title={error} showIcon status="error" size="md"/>) : null}
                </Flex>
            </ModalBody>
            <ModalFooter>
                <Button onClick={onClose} variant="secondary" marginRight={4} fontFamily="body" disabled={isSubmitting} data-testid="AddLicensePlate-button-cancel">
                    Cancel
                </Button>
                <Button form={LICENSE_PLATE_FORM_ID} type="submit" variant="primary" fontFamily="body" disabled={isSubmitting} data-testid="AddLicensePlate-button-submit" onClick={handleChangeVehicleSubmit}>
                    Save
                </Button>
            </ModalFooter>
        </Modal>);
};
export default AddLicensePlateModal;
